/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
/*global showAjaxError:true*/
/*eslint no-undef: "error"*/

window.sbBehavioursCorp = window.sbBehavioursCorp || {};
sbBehavioursCorp.authAndSubmitCorp = {
    properties: {
        isConfirmationMode: {
            type: String,
            value: "",
            notify: true
        },
        channelObject: {
            type: Object,
            notify: true,
            value:{}
        }
    },
    //channelContextVal is true if we doesn't want to send headers in request
    submitDetails: function (url, method, body, headervalue, channelContextVal, encryptedData) {
        var self = this;
        this.fire('start-processing-loader');
        let ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = url;
        ajaxCall.method = method;
        ajaxCall.body = body;

        if (channelContextVal === undefined) {
            if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
                ajaxCall.headers["authorizationDetails"] = JSON.stringify({
                    primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode : "",
                    secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode : "",
                    userId: clientStorage.get(storageType.session, 'userId'),
                    acceptTermsAndConditions: headervalue.acceptTermsAndConditions ? headervalue.acceptTermsAndConditions : "",
                    isConfirmationMode: this.isConfirmationMode ? this.isConfirmationMode : "",
                    customParameters:{
                    ochTransactionId:headervalue.ochTransactionId ? headervalue.ochTransactionId : "",
                    authorizationMode:headervalue.authorizationMode ?headervalue.authorizationMode:""
                    }
                });
            }

            if (headervalue.workflowInput) {
                var finalHeaders = JSON.parse(ajaxCall.headers["authorizationDetails"]);
                finalHeaders.workflowInput = headervalue.workflowInput ? headervalue.workflowInput : "";
                ajaxCall.headers["authorizationDetails"] = JSON.stringify(finalHeaders);
            }
        } else {
            ajaxCall.headers["authorizationDetails"] = "";
        }

        if (encryptedData !== undefined) {
            ajaxCall.headers["encrypteddata"] = sbEncrypt.encrypt(JSON.stringify(encryptedData));
        }

        ajaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false; //Status Code 204 has been added for delete functionality

            if (event.detail.__data.statusCode === 200 || event.detail.__data.statusCode === 204 || event.detail.__data.status === 200 || event.detail.__data.status === 204) {
                self.successMessage = event.detail.__data.statusCode;
                if (typeof self._callSucessPage == 'function') self._callSucessPage(event);
            }
        });
        ajaxCall.addEventListener('error', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;

            if (event.detail.request.__data.statusCode === 503 || event.detail.request.__data.response.error.statusCode === 503) {
                showAjaxError(event);
            } else if (event.detail.request.__data.statusCode === 401 || event.detail.request.__data.response.error.statusCode === 401) {
                var responseHeader = JSON.parse(event.detail.request.xhr.getResponseHeader('channelcontext')); //Need to check if workflow is enabled or not hence this variable is set

                self.channelContext = responseHeader;
                self.channelObject=self.channelContext;

                if (responseHeader.authorization != undefined) {
                    self.set("isConfirmationMode", responseHeader.authorization.isConfirmationMode);
                    this.header = {
                        "primaryAccessCode": responseHeader.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": responseHeader.authorization.secondAuthorizationMode,
                        "isConfirmationMode": this.isConfirmationMode ? this.isConfirmationMode : ""
                    };
                    self.headerObject = this.header;
                    self.setAuthorizationModes(this.header);
                    self.fromPreview=false;
                    self._callAuthPage();
                    self.fromPreview=true;
                } else {
                    if (typeof self._errorHandler == 'function') self._errorHandler(event);
                    showAjaxError(event);
                }
            } else {
                //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
                var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                var headers = convertedArr.reduce(function (each, current) {
                    var parts = [current.split(": ", 1).toString(), current.split(": ").slice(1).join(": ")];
                    each[parts[0]] = parts[1];
                    return each;
                }, {});

                if (headers.channelcontext) {
                    if (typeof self._errorHandler == 'function') self._errorHandler(event); else showAjaxError(event);
                } else showAjaxError(event);
            }
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    setAuthorizationModes: function (header) {
        this.authMethods = [];

        if (header.primaryAccessCode == "TPWD" && (!header.secondaryAccessCode || header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }];
        }

        if (header.primaryAccessCode == "SOTP" && (!header.secondaryAccessCode || header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }

        if (header.primaryAccessCode == "TPWD" && header.secondaryAccessCode == "SOTP" || header.secondaryAccessCode == "OTP") {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }, {
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }

        if (header.primaryAccessCode == "SOTP" && header.secondaryAccessCode == "TPWD") {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }, {
                'method': 'TPWD',
                'wrapperValue': ''
            }];
        }
    },
    authenticationValidation: function (autharray) {
        var authMethodLength = autharray.length;

        for (var i = 0; i < authMethodLength; i++) {
            if (autharray[i].method == "OTP" || autharray[i].method == "SOTP") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_OTPMandatory"));
                    return true;
                }
            } else if (autharray[i].method == "TPWD") {
                if (!autharray[i].wrapperValue) {
                    this.fire('oe-show-error', getLabel("m_TPWDMandatory"));
                    return true;
                }
            }
        }
    },
    workflowFinancial: function (txnType, txnAmount, txnCurrency) {
        var self = this;
        var prpmAjaxCall = document.createElement('oe-ajax');
        prpmAjaxCall.contentType = "application/json";
        prpmAjaxCall.handleAs = "json";
        prpmAjaxCall.url = "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=MULTIPLE_APPROVALS_SELECTION_AVAILABLE";
        prpmAjaxCall.method = "get";
        prpmAjaxCall.addEventListener('response', function (event) {
            var response = event.detail && event.detail.response;
            var multipleApproval;

            if (response[0].propertyValue === "N") {
                multipleApproval = false;
            } else {
                multipleApproval = true;
            }

            self.fetchWorkflowRules(txnType, txnAmount, txnCurrency, multipleApproval);
        });
        oeAjaxEventListner(prpmAjaxCall);
        prpmAjaxCall.generateRequest();
    },
    nonFinancialWorkflow: function (nonFinancialType) {
        var self = this;
        var nonFinPrpmAjaxCall = document.createElement('oe-ajax');
        nonFinPrpmAjaxCall.contentType = "application/json";
        nonFinPrpmAjaxCall.handleAs = "json";
        nonFinPrpmAjaxCall.url = "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=MULTIPLE_APPROVALS_SELECTION_AVAILABLE";
        nonFinPrpmAjaxCall.method = "get";
        nonFinPrpmAjaxCall.addEventListener('response', function (event) {
            var response = event.detail && event.detail.response;
            var nonFinMultipleApproval;

            if (response[0].propertyValue === "N") {
                nonFinMultipleApproval = false;
            } else {
                nonFinMultipleApproval = true;
            }

            var nonFinWorkflowAjaxCall = document.createElement('oe-ajax');
            nonFinWorkflowAjaxCall.contentType = "application/json";
            nonFinWorkflowAjaxCall.handleAs = "json";
            nonFinWorkflowAjaxCall.url = "api/WorkflowRules/" + nonFinancialType + "?filter[where][multienabled]=" + nonFinMultipleApproval;
            nonFinWorkflowAjaxCall.method = "get";
            nonFinWorkflowAjaxCall.addEventListener('response', function (event) {
                var response = event.detail && event.detail.response;
                self.setApproverDetails(response, nonFinMultipleApproval);
            });
            oeAjaxEventListner(nonFinWorkflowAjaxCall);
            nonFinWorkflowAjaxCall.generateRequest();
        });
        oeAjaxEventListner(nonFinPrpmAjaxCall);
        nonFinPrpmAjaxCall.generateRequest();
    },
    fetchWorkflowRules: function (txnType, txnAmount, txnCurrency, multipleApproval) {
        var self = this;
        var workflowAjaxCall = document.createElement('oe-ajax');
        workflowAjaxCall.contentType = "application/json";
        workflowAjaxCall.handleAs = "json";

        if (txnAmount == "" && txnCurrency == "") {
            workflowAjaxCall.url = "api/WorkflowRules/" + txnType + "?filter[where][multienabled]=" + multipleApproval;
        } else {
            workflowAjaxCall.url = "api/WorkflowRules/" + txnType + "?filter[where][transactionAmount]=" + txnAmount + "&filter[where][transactionCurrency]=" + txnCurrency +
                "&filter[where][multienabled]=" + multipleApproval;
        }
        workflowAjaxCall.method = "get";
        workflowAjaxCall.addEventListener('response', function (event) {
            var response = event.detail && event.detail.response;
            self.setApproverDetails(response, multipleApproval);
        });
        oeAjaxEventListner(workflowAjaxCall);
        workflowAjaxCall.generateRequest();
    },

    setApproverDetails: function (response, multipleApproval) {
        var self = this;
        if (response.error != undefined) {
            self.fire('oe-show-error', response.error);
        } else {
            if (response.length != 0) {
                if (response.followHierarchy.cmCode === "Y") {
                    self.followHierarchy = true;
                } else {
                    self.followHierarchy = false;
                }
                var approverLevelArray = [];
                self.workflowresponse = response;
                if (!(response.futureRule == undefined || response.futureRule == null || response.futureRule.length == 0)) {
                    self.futurerule = response.futureRule;
                    self.parseFutureRule(response.futureRule);
                    self.ruleId = response.ruleId;
                    var tempProgressDetails = new Array();
                    var numofapprovers = [];
                    if (self.ruleDefinition.indexOf(" + ") > -1) {
                        approverLevelArray = self.ruleDefinition.split(" + ");
                        var tmpApprovers = [];
                        for (let i = 0; i < approverLevelArray.length; i++) {
                            tmpApprovers.push(self.getRoleName(approverLevelArray[i].split(" ")[1], response));
                            self.ruleDefinition = _.replace(self.ruleDefinition, approverLevelArray[i].split(" ")[1], self.getRoleName(approverLevelArray[i].split(" ")[1], response))
                            numofapprovers[i] = approverLevelArray[i].split(" ")[0];
                        }
                        approverLevelArray = tmpApprovers;
                    } else {
                        approverLevelArray.push(self.getRoleName(self.ruleDefinition.split(" ")[1], response));
                        self.ruleDefinition = _.replace(self.ruleDefinition, self.ruleDefinition.split(" ")[1], self.getRoleName(self.ruleDefinition.split(" ")[1], response))
                        numofapprovers[0] = self.ruleDefinition.split(" ")[0];
                    }
                    if (multipleApproval === true && approverLevelArray.length > 1) {
                        var indexOfUserDetails = 0;
                        if (self.followHierarchy === false) {
                            var groupedbyarray = self.groupbyRoleID(response.approvers[0].userDetails);
                            tempProgressDetails = new Array(Object.keys(groupedbyarray).length);
                            for (let i = 0; i < approverLevelArray.length; i++) {
                                var approvercount = self.matchRoleCount(groupedbyarray[Object.keys(groupedbyarray)[i]][0].roleDescription, self.ruleDefinition);
                                var index = self.indexOfRole(groupedbyarray[Object.keys(groupedbyarray)[i]][0].roleDescription, self.ruleDefinition);

                                tempProgressDetails[index] = {};
                                tempProgressDetails[index]["primaryText"] = groupedbyarray[Object.keys(groupedbyarray)[i]][0].roleDescription;
                                tempProgressDetails[index]["secondaryText"] = "";
                                tempProgressDetails[index]["userDetails"] = groupedbyarray[Object.keys(groupedbyarray)[i]];
                                tempProgressDetails[index]["numofApprovers"] = approvercount;
                                tempProgressDetails[index]["approverLevel"] = index;
                                tempProgressDetails[index]["approversList"] = [];
                                tempProgressDetails[index]["approverIds"] = [];
                            }
                        } else {
                            for (let i = 0; i < approverLevelArray.length; i++) {
                                tempProgressDetails.push({
                                    "primaryText": approverLevelArray[i],
                                    "secondaryText": "",
                                    "userDetails": response.approvers[indexOfUserDetails].userDetails,
                                    "numofApprovers": parseInt(numofapprovers[i]),
                                    "approverLevel": i,
                                    "approversList": [],
                                    "approverIds": []
                                });
                                indexOfUserDetails = indexOfUserDetails + parseInt(numofapprovers[i]);
                            }
                        }
                    } else {
                        tempProgressDetails.push({
                            "primaryText": approverLevelArray[0],
                            "secondaryText": response.approvers[0].userDetails.length,
                            "userDetails": response.approvers[0].userDetails,
                            "numofApprovers": parseInt(numofapprovers[0]),
                            "approverLevel": 0,
                            "approversList": [],
                            "approverIds": []
                        })
                    }

                    self.progressDetails = tempProgressDetails;
                    self.approverList = response.approvers[0];
                    self.approversPost = [];
                }
            } else {
                self.workflowresponse = [];
            }
            self._callWorkflowPage();
        }
    },
    //channelContextVal is true if we doesn't want to send headers in request
    submitNonFinDetails: function (url, method, body, headervalue, transactionType, channelContextVal) {
        var self = this;
        this.fire('start-processing-loader');
        let ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = url;
        ajaxCall.method = method;
        ajaxCall.body = body;

        if (channelContextVal === undefined) {
            if (ajaxCall.header == undefined || Object.keys(ajaxCall.header).length == 0) {
                ajaxCall.headers["authorizationDetails"] = JSON.stringify({
                    primaryAccessCode: headervalue.primaryAccessCode ? headervalue.primaryAccessCode : "",
                    secondaryAccessCode: headervalue.secondaryAccessCode ? headervalue.secondaryAccessCode : "",
                    userId: clientStorage.get(storageType.session, 'userId'),
                    acceptTermsAndConditions: headervalue.acceptTermsAndConditions ? headervalue.acceptTermsAndConditions : ""
                });
            }

            if (headervalue.workflowInput) {
                var finalHeaders = JSON.parse(ajaxCall.headers["authorizationDetails"]);
                finalHeaders.workflowInput = headervalue.workflowInput ? headervalue.workflowInput : ""
                ajaxCall.headers["authorizationDetails"] = JSON.stringify(finalHeaders);
            }
        } else {
            ajaxCall.headers["authorizationDetails"] = "";
        }

        ajaxCall.addEventListener('response', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            //Status Code 204 has been added for delete functionality
            if (event.detail.__data.statusCode === 200 || event.detail.__data.statusCode === 204) {
                self.successMessage = event.detail.__data.statusCode;
                if (typeof self._callSucessPage == 'function')
                    self._callSucessPage(event);
            }
        });
        ajaxCall.addEventListener('error', function (event) {
            self.fire('stop-processing-loader');
            self.loaderActive = false;
            if (event.detail.request.__data.statusCode === 503) {
                showAjaxError(event);
            } else if (event.detail.request.__data.status === 401) {
                var responseHeader = JSON.parse(event.detail.request.xhr.getResponseHeader('channelcontext'));
                //Need to check if workflow is enabled or not hence this variable is set
                self.channelContext = responseHeader; 
                self.channelObject=self.channelContext;
                if (responseHeader.authorization != undefined) {
                    this.header = {
                        "primaryAccessCode": responseHeader.authorization.firstAuthorizationMode,
                        "secondaryAccessCode": responseHeader.authorization.secondAuthorizationMode
                    }
                    self.headerObject = this.header;
                    self.setAuthorizationModes(this.header);

                    if (responseHeader.authorization.workFlowRequired === 'Y')
                        self.nonFinancialWorkflow(transactionType);
                    else
                        self._callAuthPage();
                        self.fromPreview=true;
                } else {
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    showAjaxError(event);
                }
            } else {
                //Headers is obtained as a single string and JSON.stringify will stringify the whole string hence broken down
                var convertedArr = event.detail.request.xhr.getAllResponseHeaders().split('\r\n');
                var headers = convertedArr.reduce(function (each, current) {
                    var parts = [current.split(": ", 1).toString(), current.split(": ").slice(1).join(": ")];
                    each[parts[0]] = parts[1];
                    return each;
                }, {});
                if (headers.channelcontext) {
                    if (typeof self._errorHandler == 'function')
                        self._errorHandler(event);
                    else
                        showAjaxError(event);
                } else
                    showAjaxError(event);
            }
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();

    },

    dateParse: function (d) {
        return d.toISOString().slice(0, 19);
    },
    _recurringDetailsCheck: function (recurringDate, frequencyIndex, numberOfDays, numberofInstallments) {
        if (frequencyIndex != 0) {
            if (!numberofInstallments || numberofInstallments < 2) {
                this.fire('oe-show-error', {
                    code: 'm_EnterInstallments'
                });
                return false;
            }

            if (frequencyIndex == 8) {
                if (numberOfDays == 0) {
                    this.fire('oe-show-error', {
                        code: 'm_EnterNumberOfDays'
                    });
                    return false;
                }
            }
        }
        return true;
    },

    parseFutureRule: function (futureRule) {
        var self = this;
        futureRule = _.trimEnd(futureRule, '|');
        self.ruleDefinition = _.replace(futureRule, /\|/g, ' + ');
        self.ruleDefinition = _.replace(self.ruleDefinition, /\^/g, ' ');
    },

    getRoleName: function (approveRoleId, response) {
        for (var index = 0; index < response.role.length; index++) {
            if (response.role[index].roleId === approveRoleId) {
                return response.role[index].roleDescription;
            }
        }
    },

    groupbyRoleID: function (userDetails) {

        var groupBy = function (xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        return groupBy(userDetails, 'roleId')
    },

    matchRoleCount: function (roleDescription, ruleDefinition) {

        var ruleArray = ruleDefinition.split(" + ");
        for (var i = 0; i < ruleArray.length; i++) {

            if (ruleArray[i].indexOf(roleDescription) !== -1) {
                return parseInt(ruleArray[i].split(" ")[0]);
            }
        }
    },

    checkandAddRoleIfAny: function () {
        var count = [];
        this.approversTemp = [];
        for (var i = 0; i < this.approversPost.length; i++) {
            this.approversTemp.push(this.approversPost[i]);
        }
        for (var index = 0; index < this.progressDetails.length; index++) {

            count[index] = this.approversTemp.filter(function (v) {
                return v.approverLevel == index
            }).length;

            if (count[index] < this.progressDetails[index].numofApprovers) {
                for (var fillIndex = count[index]; fillIndex < this.progressDetails[index].numofApprovers; fillIndex++)
                    this.push('approversTemp', { 'approverLevel': index, 'userName': '' });
            }
        }

        this.approversTemp.sort(function (a, b) {
            return a.approverLevel - b.approverLevel;
        });
    },

    indexOfRole: function (roleDescription, ruleDefinition) {
        var ruleArray = ruleDefinition.split(" + ");
        for (var i = 0; i < ruleArray.length; i++) {

            if (ruleArray[i].indexOf(roleDescription) !== -1) {
                return i;
            }
        }
    }
}